export function SmartcarLightIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.49 0C5.591 0 0 5.59 0 12.486 0 19.38 5.592 24.97 12.49 24.97c6.897 0 12.489-5.59 12.489-12.485S19.387 0 12.489 0zm0 3.121c4.064 0 7.498 2.617 8.793 6.243H3.696c1.295-3.626 4.73-6.243 8.793-6.243zm0 10.925a1.561 1.561 0 110-3.122 1.561 1.561 0 010 3.122zm-9.368-1.56c4.266 0 7.72 4.108 7.794 9.205-4.415-.756-7.794-4.581-7.794-9.205zm10.94 9.205c.074-5.096 3.529-9.205 7.795-9.205 0 4.624-3.379 8.45-7.794 9.205z"
        fill="#1C1C1C"
      />
    </svg>
  );
}

export function SmartcarDarkIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.49 0C5.591 0 0 5.59 0 12.486 0 19.38 5.592 24.97 12.49 24.97c6.897 0 12.489-5.59 12.489-12.485S19.387 0 12.489 0zm0 3.121c4.064 0 7.498 2.617 8.793 6.243H3.696c1.295-3.626 4.73-6.243 8.793-6.243zm0 10.925a1.561 1.561 0 110-3.122 1.561 1.561 0 010 3.122zm-9.368-1.56c4.266 0 7.72 4.108 7.794 9.205-4.415-.756-7.794-4.581-7.794-9.205zm10.94 9.205c.074-5.096 3.529-9.205 7.795-9.205 0 4.624-3.379 8.45-7.794 9.205z"
        fill="#FFFFFF"
      />
    </svg>
  );
}
